import script from "./ProjectCapexPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectCapexPage.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectCapexPage.vue?vue&type=style&index=0&id=6bc43618&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bc43618"]])

export default __exports__